
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supplier-application",
      function () {
        return require("private-next-pages/supplier-application/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supplier-application"])
      });
    }
  